import { useState } from 'react';
import SwitchComponent from '../../../components/commons/Switch/SwitchComponent';
import { useTranslate } from '../../../context/languageContext';
import { R } from '../../../R';
import { useCookies } from 'react-cookie';
import { useGoogleAnalytics } from '../../../../utils/useGoogleAnalytics';

export default function ManageCookiesScreen(props: any) {

  const [cookies, setCookie, removeCookie] = useCookies(['cookieConsent']);
  const [userHasAccepted, setUserHasAccepted] = useState(cookies.cookieConsent ? true : false);
  const t = useTranslate();
  const { clearGACookies } = useGoogleAnalytics();

  const Ic_Cookies = R.drawables.account.cookie;

  const onChangeCookieesConsent = () => {
   if(userHasAccepted) {
      removeCookie('cookieConsent', { path: '/' });
      clearGACookies();
      localStorage.setItem('cookieDecision', 'declined');
      setUserHasAccepted(false);
   } else {
      setCookie('cookieConsent', 'true', { path: '/', maxAge: 60 * 60 * 24 * 365 });
      localStorage.setItem('cookieDecision', 'accepted');
      setUserHasAccepted(true);
   }
  };

  return (
    <div className="account-child content">
      <div className="titleAccount">{t('cookies_account_section')}</div>
      <>
        <div className="content-notifications">
          <div className="account-notifications">
            <div className="account-notifications-top">
              <Ic_Cookies />
              <h4>{t('cookies_account_description')}</h4>
              <SwitchComponent
                onCheck={onChangeCookieesConsent}
                idKey="alerts"
                isChecked={userHasAccepted}
              />
            </div>
          </div>
        </div>
      </>
    </div>
  );
}
